module.exports = "/_next/static/images/plane2-line-4ca812d0a12b433b1e3fc4a522d8d7e8.svg";